/**
 * px 转 rem 工具函数
 * 基于项目的基准字体大小 16px
 */

// 基准字体大小
const BASE_FONT_SIZE = 16;

/**
 * 将像素值转换为 rem 值
 * @param {number} px - 像素值
 * @param {number} baseSize - 基准字体大小，默认 16
 * @returns {string} rem 值字符串
 */
export function px2rem(px, baseSize = BASE_FONT_SIZE) {
  if (typeof px !== 'number' || px < 0) {
    console.warn('px2rem: 请输入有效的正数像素值');
    return '0rem';
  }
  return (px / baseSize) + 'rem';
}

/**
 * 批量转换像素值为 rem 值
 * @param {Object} styles - 包含像素值的样式对象
 * @param {number} baseSize - 基准字体大小，默认 16
 * @returns {Object} 转换后的样式对象
 */
export function px2remBatch(styles, baseSize = BASE_FONT_SIZE) {
  const result = {};
  for (const [key, value] of Object.entries(styles)) {
    if (typeof value === 'number') {
      result[key] = px2rem(value, baseSize);
    } else if (typeof value === 'string' && value.includes('px')) {
      // 处理已经是字符串的 px 值
      const pxValue = parseFloat(value);
      if (!isNaN(pxValue)) {
        result[key] = px2rem(pxValue, baseSize);
      } else {
        result[key] = value;
      }
    } else {
      result[key] = value;
    }
  }
  return result;
}

/**
 * 创建响应式的 rem 值
 * @param {number} px - 像素值
 * @param {number} baseSize - 基准字体大小，默认 16
 * @returns {string} 响应式的 rem 值字符串
 */
export function responsiveRem(px, baseSize = BASE_FONT_SIZE) {
  return `calc(${px2rem(px, baseSize)} * var(--responsive-scale, 1))`;
}

// 常用尺寸的快捷方法
export const commonSizes = {
  xs: () => px2rem(8),      // 8px -> 0.5rem
  sm: () => px2rem(12),     // 12px -> 0.75rem
  md: () => px2rem(16),     // 16px -> 1rem
  lg: () => px2rem(24),     // 24px -> 1.5rem
  xl: () => px2rem(32),     // 32px -> 2rem
  xxl: () => px2rem(48),    // 48px -> 3rem
};

export default {
  px2rem,
  px2remBatch,
  responsiveRem,
  commonSizes,
};
